import { create } from "zustand";
import { expenses as seed } from "@/mocks/seed";
import type { Expense } from "@/types";

/** Mock store for expenses when unauthenticated / API down (Phase 5.3). */
interface ExpensesState {
  active: Expense[];
  archived: Expense[];
  add: (expense: Expense) => void;
  update: (id: string, patch: Partial<Expense>) => void;
  archive: (id: string) => void;
  restore: (id: string) => void;
}

export const useExpensesStore = create<ExpensesState>((set) => ({
  active: seed,
  archived: [],
  add: (expense) => set((s) => ({ active: [expense, ...s.active] })),
  update: (id, patch) =>
    set((s) => ({ active: s.active.map((e) => (e.id === id ? { ...e, ...patch } : e)) })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((e) => e.id === id);
      if (!target) return s;
      return { active: s.active.filter((e) => e.id !== id), archived: [target, ...s.archived] };
    }),
  restore: (id) =>
    set((s) => {
      const target = s.archived.find((e) => e.id === id);
      if (!target) return s;
      return { archived: s.archived.filter((e) => e.id !== id), active: [target, ...s.active] };
    }),
}));
